<template>
    <div class="background" :style="{'background': 'url(' + theImage + ')'}">
        <div class="transbox">
            <div class="transboxContent">
                <h2>{{ $t('home.Header') }}</h2>
            </div>
        </div>
        <div id="image_holder" class="imageHolder" style="overflow:scroll">
            <div id="scheduler">
            </div>
        </div>
        <div class="transbox">
            <div class="transboxContent">
                <br />
                <br />
                <br />
                <br />
                <br />
            </div>
        </div>
    </div>
</template>

<script type="text/javascript">
    import $ from 'jquery';
    import { EventBus } from '@/classes/eventBus.js';
    import '@progress/kendo-ui';
    import '@progress/kendo-theme-default/dist/all.css';
    import { Scheduler, SchedulerView } from '@progress/kendo-scheduler-vue-wrapper';
    import { KendoSchedulerDataSource } from '@progress/kendo-datasource-vue-wrapper';
    import kendo from '@progress/kendo-ui';
    import config from "@/appdata/config.json";

    export default {
        name: 'App',
        components: {
            'kendo-scheduler': Scheduler,
            'kendo-scheduler-view': SchedulerView,
            'kendo-schedulerdatasource': KendoSchedulerDataSource
        },
        props: {
        },
        data: function () {
            return {
                theImage: ''
            }
        },
        created() {
        },
        mounted() {
            window.$ = kendo.jQuery;
            EventBus.$on('backgroundImageChange', image => {
                this.theImage = image;
            });
            EventBus.$on('languageChanged', () => {
                this.initScheduler();
            });
            this.initScheduler();
        },
        methods: {
            initScheduler() {
                let language = this.$i18n.locale;
                if (language === "de") {
                    language = "de-DE";
                } else {
                    language = "en-GB";
                }
                let baseUrlMessages = 'https://kendo.cdn.telerik.com/2021.2.511/js/messages/kendo.messages.';
                let baseUrlCultures = 'https://kendo.cdn.telerik.com/2021.2.511/js/cultures/kendo.culture.';

                if (language === "en-GB") {
                    kendo.ui.Scheduler.fn.options.messages.pdf = "Export to PDF";
                }

                $.getScript("https://kendo.cdn.telerik.com/2021.2.511/js/kendo.timezones.min.js", function () {
                    $.getScript(baseUrlMessages + language + ".min.js", function () {
                        $.getScript(baseUrlCultures + language + ".min.js", function () {
                            kendo.culture(language);
                            kendo.ui.progress($("#scheduler"), false);
                            //createScheduler();
                            const url = config[0].ServiceUrl + config[0].ServiceUrlPort + "/Termine"
                            var element = $("#scheduler");
                            if (element.data("kendoScheduler")) {
                                element.data("kendoScheduler").destroy();
                                element.empty();
                            }

                            element.kendoScheduler({
                                dataSource: {
                                    transport: {
                                        read: {
                                            url: url,
                                            dataType: 'jsonp'
                                        }
                                    },
                                    schema: { 
                                        model: {
                                            id: "taskId",
                                            fields: {
                                                taskId: { from: "TaskID", type: "number" },
                                                title: { from: "Title", defaultValue: "No title", validation: { required: true }},
                                                start: { type: "date", from: "Start" },
                                                end: { type: "date", from: "End" },
                                                startTimezone: { from: "StartTimezone" },
                                                endTimezone: { from: "EndTimezone" },
                                                description: { from: "Description" },
                                                recurrenceId: { from: "RecurrenceID" },
                                                recurrenceRule: { from: "RecurrenceRule" },
                                                recurrenceException: { from: "RecurrenceException" },
                                                ownerId: { from: "OwnerID", defaultValue: 1 },
                                                isAllDay: { type: "boolean", from: "IsAllDay" }
                                            }
                                        }
                                    }
                                },
                                height: "500",
                                toolbar: ['pdf'],
                                kendoFileName: 'Terminagenda.pdf',
                                timezone: 'Europe/Berlin',
                                editable: false,
                                date: new Date(),
                                startTime: new Date(),
                                mobile: "true",
                                views: [
                                    { type: "agenda", selected: true }
                                ]
                            });
                        });
                    });
                });
            }
        }
    }
</script>
<style scoped>
    /*Scheduler - Start*/
    #scheduler.k-widget.k-scheduler.k-floatwrap {
        min-width: 700px;
    }
    /*Scheduler - Ende*/
    @import '../css/main.css';
</style>

